export default __webpack_public_path__ + "static/media/cinnamon.e897efc3.jfif";